import React from 'react'

import Button from '../common/button'

const actionButtonStyle = { width: 80, height: 30, padding: 0, marginLeft: 5 }

const TripsTableComponent = (props) => {
  return (
    <div className="row etm-tickets-table-wrp">
      <table className="payout-table">
        <thead>
          <tr className="payout-table-header">
            <th>Trip Id</th>
            <th>Start Time</th>
            <th>End Time</th>
            <th>Bus Number</th>
            <th>Conductor Name</th>
            <th>Total Fare Collected</th>
            <th>Ticket Details</th>
          </tr>
        </thead>
        <tbody>
          {
            !props.tableData.length && <tr><td colSpan={7} className="table-no-data">No Data Found</td></tr>
          }
          {
            props.tableData.map((el, i) => (
              <tr key={el.tripId} className="payout-table-row">
                <td>{el.tripId}</td>
                <td>{el.tripStartTime || '-'}</td>
                <td>{el.tripEndTime || '-'}</td>
                <td>{el.busNumber || '-'}</td>
                <td>{el.conductorUsername || '-'}</td>
                <td>{el.totalFare || '-'}</td>
                <td>
                  <Button
                    styleObj={actionButtonStyle}
                    label="Details"
                    onButtonClick={() => props.onTripDetailsClick(el.tripId)}
                  />
                </td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  )
}

export default TripsTableComponent